export default "/images/search_empty_icon.svg?217b7b0d30557f868c0b561e01af0565";